module.exports = __webpack_public_path__ + "static/media/profileIcon.cc4d8c61.svg";